<!--
  护林页面参数介绍：
  lon：经度
  lat：纬度
  zrqobjid:责任区id
  zrqlx:责任区类型
  from: lztandroid(林长通安卓) 、lztios（林长通iOS）、hltandroid（护林通安卓）
-->
<template>
  <div class="dhmap-wrapper hulinPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <div v-if="!showNonePage" class="xunlinBox">
      <van-cell-group class="currentZrqPosition">
        <van-field
          :class="{ disabled: flagWalking }"
          :disabled="flagWalking"
          label="责任区名称："
          left-icon="location-o"
          :right-icon="zrqDataLength > 1 ? 'arrow' : ''"
          v-model="zrqName"
          readonly
          @click="checkZrqPicker"
        />
      </van-cell-group>
      <div class="infobox" v-if="infotip">
        <div
          class="infotip"
          v-if="flagPosition"
          style="background-color: #1989fa"
        >
          未获取到位置信息！
        </div>
        <div class="infotip" v-if="flagZrq" style="background-color: #1989fa">
          暂未分配责任区！
        </div>
        <div class="infotip" v-if="flagInzrq" style="background-color: #1989fa">
          {{
            showQd
              ? "用户不在责任区，无法签到或巡林！"
              : "用户不在责任区，无法巡林！"
          }}
        </div>
        <div
          class="infotip"
          v-if="flagWalking"
          style="background-color: #58bd6b"
        >
          <!-- <van-loading size="20" color="#fff"></van-loading> -->
          <span style="color: #fff">
            正在巡林&nbsp;
            <span
              style="display: inline-block; width: 20px; text-align: left"
              >{{ loadingtext }}</span
            >
          </span>
        </div>
      </div>
      <div id="protectmap" ref="protectmap"></div>
      <van-popup
        v-model="showQiandaoType"
        round
        class="XunlinPicker"
        position="bottom"
        :style="{ height: '60%' }"
      >
        <div class="xunlinMain">
          <div class="qiandaoMain">
            <van-field
              v-model="qdremark"
              rows="2"
              autosize
              label="签到说明"
              type="textarea"
              maxlength="50"
              placeholder="请输入签到说明（可不填）"
              show-word-limit
            />
            <van-radio-group v-model="listTypeQdSelected">
              <van-cell-group>
                <van-cell
                  v-for="item in listTypeQd"
                  :key="item.code"
                  :title="item.name"
                  clickable
                  @click="listTypeQdSelected = item.code"
                >
                  <van-radio slot="right-icon" :name="item.code" />
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
          <van-goods-action
            :safe-area-inset-bottom="true"
            class="btnBox handleQd"
          >
            <van-goods-action-button
              type="primary"
              block
              round
              @click="handleQd"
              >确认签到</van-goods-action-button
            >
          </van-goods-action>
        </div>
      </van-popup>
      <div class="gistoolbox btnBox">
        <van-button plain type="info" round @click="locatePosition">
          <van-icon name="location-o" size="16" />
        </van-button>
        <van-button plain type="info" round @click="locateGlobel">
          <img src="../../assets/gisicon/icon_globle.png" />
        </van-button>
      </div>
      <!-- 弹出框 -->
      <van-popup v-model="selectZrqPicker" class="zrqPickerPage">
        <zrq-select :zrqData="zrqData" @getData="changeZrq"></zrq-select>
      </van-popup>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
const zrqSelect = () => import("@/components/zrqSelect/zrqSelect");
import { mapState } from "vuex";
import "ol/ol.css";
import {
  initMap,
  addLayerToMap,
  actLocate,
  getLayerByType,
  removeAllLayersExceptBaseMap,
} from "@/utils/MapUtils";
import { Vector as VectorLayer } from "ol/layer.js";
import VectorSource from "ol/source/Vector.js";
import { Style, Stroke, Fill, Text, Circle, Icon } from "ol/style.js";
import { locateStyleCollection } from "@/utils/MapIcons";
import { Point, LineString, Polygon } from "ol/geom";
import Feature from "ol/Feature";
import { fromLonLat, transformExtent } from "ol/proj";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
// import * as jsts from 'jsts/dist/jsts.min.js'

export default {
  name: "protector",
  components: { zrqSelect },
  props: {},
  data() {
    return {
      zrqName: "",
      isIn:false,
      selectZrqPicker: false,
      infotip: false,
      flagPosition: false,
      flagZrq: false,
      flagInzrq: false,
      flagWalking: false,
      showQd: true,
      showQiandaoType: false,
      param: {},
      map: null,
      gisconfig: {},
      zrqVector: null,
      zrqSourceVector: null,
      zrqStyle: new Style({
        stroke: new Stroke({
          color: "#2a32fc",
          width: 5.5,
        }),
      }),
      gjVector: null,
      gjSourceVector: null,
      gjStyle: new Style({
        // stroke: new Stroke({
        //   color: '#000000',
        //   width: 5.5
        // })
      }),
      gjManStyle: locateStyleCollection["default"],
      currentTask: null,
      listTypeQd: [],
      listTypeQdSelected: null,
      qdremark: "",
      lzFeature: null,
      zrqFeature: null,
      gjFeature: null,
      gjLineFeature: null,
      coordinate: [], //轨迹点的集合，二维数组
      loadingtext: "",
      clientType: "",
      zrqData: {
        uid: "",
        objid: "",
        zrqName: "",
        zqCode: "",
        zrqlx: "",
        level: "",
      },
      zrqDataLength: 0, //责任区多少
      firstLocation: true, //进页面调用轨迹
      showNonePage: true, //展示加载中
    };
  },
  mounted() {
    if (this.userinfo.uid) {
      this.initData();
    }
    window.locationPosition = this.locationSelf; //调用安卓定位方法
    window.actionQd = this.actionQd; //调用安卓定位方法
    window.stopWalk = this.stopLocation; //停止巡林调用安卓
    this.clientType = getDeviceType();
    //经纬度参数必传校验
    if (!this.$route.query.lon || !this.$route.query.lat) {
      this.infotip = true;
      this.flagPosition = true;
    }
    this.param.lon = this.$route.query.lon;
    this.param.lat = this.$route.query.lat;
    if (this.$route.query.from == "hltandroid") {
      console.log(900000111);
      this.showQd = false;
    }
    //加载字典
    this.loadDict();
    var _this = this;
    setInterval(function () {
      if (_this.loadingtext.length == 3) {
        _this.loadingtext = "";
      }
      _this.loadingtext = _this.loadingtext + ".";
    }, 900);
  },
  methods: {
    //根据责任区去加载地图
    zrqInfo() {
      //绘制责任区边界和用户自己的位置
      this.drawZrqAndUserPosition();
    },
    //根据责任区切换地图图层
    loadZrq() {
      let _this = this;
      if (!this.map) {
        return;
      }
      removeAllLayersExceptBaseMap(this.map);
      //添加图层
      addLayerToMap(_this.map, _this.gisconfig, null, [
        "tdtjd",
        "tdtzj",
        "geo_sheng",
        "geo_shi",
        "geo_xian",
        "geo_xiang",
        "geo_cun",
      ]);
      getLayerByType(_this.map, "tdt").setVisible(true);
      _this.initVectorLayer();
      //绘制责任区边界和用户自己的位置
      _this.drawZrqAndUserPosition();
    },
    //根据uid查看用户责任区
    initData() {
      let _this = this;
      _this.$api.universal.dutyArea
        .getDutyAreaList(_this.userinfo.uid)
        .then((res) => {
          _this.showNonePage = false;
          if (res.code == "1" && res.data) {
            _this.zrqDataLength = res.data.length;
            _this.zrqData.uid = _this.userinfo.uid;
            _this.zrqData.objid = res.data[0].objid;
            _this.zrqData.zrqName = res.data[0].zqName;
            _this.zrqData.zqCode = res.data[0].zqCode;
            _this.zrqData.level = res.data[0].level;
            _this.zrqData.type = res.data[0].type;
            let zrqIndex = res.data[0].level;
            if (_this.zrqData.type == "zq") {
              _this.zrqData.zrqlx = [
                "geo_sheng",
                "geo_shi",
                "geo_xian",
                "geo_xiang",
                "geo_cun",
              ][zrqIndex - 1];
            } else if (_this.zrqData.type == "zrq") {
              _this.zrqData.zrqlx = [
                "geo_grid_sheng",
                "geo_grid_shi",
                "geo_grid_xian",
                "geo_grid_xiang",
                "geo_grid_cun",
              ][zrqIndex - 1];
            }

            _this.zrqName = res.data[0].zqName;
            //责任区参数必传校验
            if (
              !_this.flagPosition &&
              (!_this.zrqData.objid || !_this.zrqData.zrqlx)
            ) {
              _this.infotip = true;
              _this.flagZrq = true;
            }
            //加载地图
            _this.loadMap();
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          _this.showNonePage = false;
          console.log(err);
        });
    },
    changeZrq(data) {
      let _this = this;
      this.selectZrqPicker = false;
      console.log(data);
      if (data.objid && data.zrqName) {
        _this.zrqName = data.zrqName;
        _this.zrqData.uid = _this.userId;
        _this.zrqData.objid = data.objid;
        _this.zrqData.zqCode = data.zqCode;
        _this.zrqData.level = data.level;
        _this.zrqData.type = data.type;
        let zrqIndex = data.level;
        if (_this.zrqData.type == "zq") {
          _this.zrqData.zrqlx = [
            "geo_sheng",
            "geo_shi",
            "geo_xian",
            "geo_xiang",
            "geo_cun",
          ][zrqIndex - 1];
        } else if (_this.zrqData.type == "zrq") {
          _this.zrqData.zrqlx = [
            "geo_grid_sheng",
            "geo_grid_shi",
            "geo_grid_xian",
            "geo_grid_xiang",
            "geo_grid_cun",
          ][zrqIndex - 1];
        }
        _this.zrqData.zrqName = data.zrqName;
        _this.zrqInfo();
      }
      if (_this.clientType == "android") {
        window.android.getInfo(121, "0");
      } else {
        window.webkit.messageHandlers.changeZrq.postMessage("0");
      }
    },
    checkZrqPicker() {
      let _this = this;
      if (this.zrqDataLength <= 1) {
        return false;
      }
      if (this.flagWalking) {
        this.$toast("正在巡林中，不能切换责任区!");
        return false;
      }
      if(_this.clientType == "android"){
        window.android.getInfo(120, _this.flagWalking?"1":"2");
      }
      if (_this.clientType == "android") {
        window.android.getInfo(121, "1");
      } else {
        window.webkit.messageHandlers.changeZrq.postMessage("1");
      }
      setTimeout(function () {
        _this.selectZrqPicker = true;
      }, 200);
    },
    actionQd() {
      //app点击签到
      this.showQiandaoType = true;
    },
    //定位方法，str
    locationSelf(locateArr) {
      //一分钟安卓传递坐标过来
      var _this = this;
      console.log(locateArr, 90000009);
      if (locateArr.length > 0) {
        _this.infotip = true;
        _this.flagWalking = true;
        let arr = [];
        locateArr.forEach((item) => {
          if (locateArr.length == 1) {
            arr.push([parseFloat(item.x), parseFloat(item.y)]);
          }
          arr.push([parseFloat(item.x), parseFloat(item.y)]);
        });
        this.coordinate = arr;
        let polygonArr = [];
        polygonArr.push(this.coordinate);
        let geometryLine;
        geometryLine = new LineString(_this.coordinate);
        var geometryLineFeature = new Feature(); //绘制线的数据
        geometryLineFeature.setGeometry(geometryLine);
        geometryLineFeature.setStyle(
          new Style({
            stroke: new Stroke({
              color: "#2DFFFE",
              width: 1.5,
            }),
          })
        );
        _this.gjSourceVector.clear();
        _this.gjSourceVector.addFeature(geometryLineFeature);
        _this.gjLineFeature = geometryLineFeature;
        if (_this.firstLocation) {
          _this.map.getView().setZoom(15);
        }
        _this.firstLocation = false;
        _this.map.getView().animate({
          center: [
            locateArr[locateArr.length - 1].x,
            locateArr[locateArr.length - 1].y,
          ],
          duration: 500,
        });
      }
    },
    loadMap() {
      var _this = this;
      if (_this.userinfo && _this.userinfo.appId) {
        this.$api.Mapapi.getconfig({
          appId: _this.userinfo.appId,
        })
          .then((res) => {
            if (res && res.code == 1) {
              _this.gisconfig = res.data;
              //设置该地图根据CQL进行过滤加载
              _this.gisconfig.queryWithCQL = true;
              //设置CQL进行查询，必须要提供uid、uregion、uregionlevel三个参数
              _this.gisconfig.uid = _this.userinfo.uid;
              _this.gisconfig.uregion = _this.zrqData.zqCode;
              _this.gisconfig.uregionlevel = [
                null,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                5,
              ][_this.gisconfig.uregion.length];
              //初始化地图
              _this.map = initMap("protectmap", _this.gisconfig, {
                showZoom: false,
              });
              _this.map.gisConfig = res.data;
              _this.map.gisConfig.locateType = "protector";
              //如果参数校验未通过，就不需要终止逻辑了
              if (this.flagPosition || this.flagZrq) {
                return;
              }
              //删掉谷歌底图（优化性能）、因为巡林采用天地图影像
              _this.map.removeLayer(getLayerByType(_this.map, "google"));
              _this.loadZrq();
              //注册轨迹线动画效果
              _this.addLineAnimate();
            } else {
              _this.$toast(res.msg);
            }
          })
          .catch((err) => {
            _this.$toast("地图加载异常!");
          });
      }
    },
    loadDict() {
      var _this = this;
      this.$api.Mapapi.getDict({
        parentCode: "PROTECT_SIGN_TYPE",
      }).then((res) => {
        if (res && res.code == 1) {
          _this.listTypeQd = res.data;
        } else {
          _this.$toast(res.msg);
        }
      });
    },
    drawZrqAndUserPosition() {
      //检查是否位于责任区
      var _this = this;
      console.log(_this.zrqData.zrqlx, 9999);
      if (_this.zrqData.zrqlx) {
        actLocate(
          _this.map,
          _this.zrqData.zrqlx,
          _this.zrqData.objid,
          // 'd655429a-696e-41bf-8669-edf4d0258b50',
          _this.zrqVector,
          function () {
            _this.zrqFeature = _this.zrqSourceVector.getFeatures()[0];
            //定位人员（根据lon和lat创建一个feature并添加到轨迹图层）
            if (_this.param.lon && _this.param.lat) {
              _this.lzFeature = _this.createFeatureFromLonLat(
                _this.param.lon,
                _this.param.lat
              );
              if (_this.lzFeature) {
                _this.lzFeature.is_user = true;
                _this.gjSourceVector.addFeature(_this.lzFeature);
              }
            }
            //绘制完成后，请求是否之前存在未结束的巡林
            _this.queryUnFinishedXunlin();
          }
        );
      }
    },
    queryUnFinishedXunlin() {
      var _this = this;
      //如果存在界面还原至上次巡林状态，如果不存在则启用各功能按钮
      this.$api.Mapapi.getUnfinishedProtect({})
        .then(async (res) => {
          if (res && res.code == 1) {
            if (res.data && res.data.id) {
              _this.currentTask = res.data;
              this.beginWalk();
            } else {
              //如果暂无巡林的话，还需进行用户是否位于责任区的检测
              await _this.isInGrid();
              console.log(_this.isIn,'isInisIn')
              if (
                !_this.lzFeature ||
                !_this.zrqFeature || !_this.isIn
                // !_this.zrqFeature
                //   .getGeometry()
                //   .intersectsCoordinate(
                //     _this.lzFeature.getGeometry().getFirstCoordinate()
                //   )
              ) {
                _this.infotip = true;
                _this.flagInzrq = true;
              } else {
                _this.infotip = false;
                _this.flagInzrq = false;
              }
              if (_this.clientType == "android") {
                console.log(!_this.flagInzrq, 99900000);
                window.android.getInfo(119, !_this.flagInzrq ? "1" : "0");
              } else {
                window.webkit.messageHandlers.uploadPatrolForestData.postMessage(
                  !_this.flagInzrq ? "1" : "0"
                );
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("获取未完成的巡林失败!");
        });
    },
    //判断在不在巡林范围内
    async isInGrid() {
      var _this = this;
      let point='POINT('+_this.param.lon+' '+_this.param.lat+')';
      let type=_this.zrqData.type;
      let params={
        type:type,
      }
      if(_this.zrqData.type=='zq'){
        params.param=_this.zrqData.zqCode
      }else{
        params.param=_this.zrqData.objid
      }
      await new Promise(resolve=>{
        _this.$api.Mapapi.isInGrid(point,params)
        .then((res) => {
          if (res && res.code == 1) {
            console.log(res.data,'res.datares.datares.data')
            _this.isIn=res.data
            resolve(res.data);
            return res.data
          } else {
            _this.$toast(res.msg);
            _this.isIn=false
            resolve(false);
            return false
          }
         
        })
      }) 
    },
    beginWalk() {
      let _this = this;
      if (this.currentTask && this.currentTask.id) {
        this.flagPosition = this.flagZrq = this.flagInzrq = false;
        this.infotip = true;
        this.flagWalking = true;
        if (_this.clientType == "android") {
          window.android.getInfo(119, !_this.flagInzrq ? "1" : "0");
        } else {
          window.webkit.messageHandlers.uploadPatrolForestData.postMessage(
            !_this.flagInzrq ? "1" : "0"
          );
        }
      }
    },
    // 结束巡林
    stopLocation() {
      let _this = this;
      _this.gjSourceVector.clear();
      _this.infotip = _this.flagWalking = false;
      _this.currentTask = _this.gjFeature = null;
      _this.gjLineFeature = null;
      _this.firstLocation = true;
    },
    handleQd() {
      if (!this.listTypeQdSelected) {
        this.$toast("请先选择签到类型");
        return;
      }
      var _this = this;
      this.$api.Mapapi.protectSign({
        gridObjid: _this.zrqData.objid,
        gridLevel: _this.zrqData.level,
        type: _this.listTypeQdSelected,
        point: {
          x: _this.param.lon,
          y: _this.param.lat,
        },
        remarks: _this.qdremark,
      })
        .then((res) => {
          if (res && res.code == 1) {
            this.showQiandaoType = false;
            _this.$toast.success({
              message: "签到成功！",
            });
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("签到异常!");
        });
    },
    initVectorLayer() {
      //初始化一个责任区矢量图层，用于绘制责任区
      var _this = this;
      this.zrqSourceVector = new VectorSource();
      this.zrqVector = new VectorLayer({
        source: this.zrqSourceVector,
        style: function (feature) {
          return _this.zrqStyle;
        },
      });
      this.map.addLayer(this.zrqVector);
      //初始化一个轨迹矢量图层，用于绘制轨迹或人员位置
      this.gjSourceVector = new VectorSource();
      this.gjVector = new VectorLayer({
        source: this.gjSourceVector,
        style: function (feature) {
          if (feature.getGeometry().constructor === Point) {
            return _this.gjManStyle;
          } else if (feature.getGeometry().constructor === LineString) {
            return _this.gjStyle;
          }
        },
      });
      this.map.addLayer(this.gjVector);
    },
    createFeatureFromLonLat(lon, lat) {
      return new Feature({
        geometry: new Point(fromLonLat([lon, lat], "EPSG:4326")),
      });
    },
    addLineAnimate() {
      var buttomPathStyle = new Style({
        stroke: new Stroke({
          color: [4, 110, 74],
          width: 12,
        }),
      });
      var upperPathStyle = new Style({
        stroke: new Stroke({
          color: [0, 186, 107],
          width: 8,
        }),
      });
      var runnerStyle = new Style({
        image: new Circle({
          radius: 3,
          fill: new Fill({
            color: "rgba(255, 255, 254, 1)",
          }),
        }),
      });
      var offset = 0.01;
      var _this = this;
      var baselayer = this.map.getLayers().getArray()[0];
      baselayer.on("postcompose", (evt) => {
        var vct = evt.vectorContext;
        if (_this.gjLineFeature) {
          vct.drawFeature(_this.gjLineFeature, buttomPathStyle);
          vct.drawFeature(_this.gjLineFeature, upperPathStyle);
          let numArr = Math.ceil(
            _this.gjLineFeature.getGeometry().getLength() /
              _this.map.getView().getResolution() /
              80
          );

          var points = [];
          for (var i = 0; i <= numArr; i++) {
            let fracPos = i / numArr + offset;
            if (fracPos > 1) fracPos -= 1;
            let pf = new Feature(
              new Point(
                _this.gjLineFeature.getGeometry().getCoordinateAt(fracPos)
              )
            );
            points.push(pf);
          }
          //确定方向并绘制
          _this.gjLineFeature.getGeometry().forEachSegment((start, end) => {
            points.forEach((item) => {
              let line = new LineString([start, end]);
              let coord = item.getGeometry().getFirstCoordinate();
              let cPoint = line.getClosestPoint(coord);
              if (
                Math.abs(cPoint[0] - coord[0]) < 1 &&
                Math.abs(cPoint[1] - coord[1]) < 1
              ) {
                vct.setStyle(runnerStyle);
                vct.drawGeometry(item.getGeometry());
              }
            });
          });
          offset = offset + 0.0015;
          //复位
          if (offset >= 1) offset = 0.001;
          _this.map.render();
        }
      });
    },
    locatePosition() {
      var _this = this;
      let param = {};
      if (_this.coordinate && _this.coordinate.length > 0) {
        console.log(_this.coordinate);
        let coordinate = _this.coordinate[_this.coordinate.length - 1];
        param.lon = coordinate[0];
        param.lat = coordinate[1];
      } else if (_this.param.lon && _this.param.lat) {
        param.lon = _this.param.lon;
        param.lat = _this.param.lat;
      }
      var f = _this.createFeatureFromLonLat(param.lon, param.lat);
      _this.gjSourceVector.addFeature(f);
      _this.map.getView().animate({
        center: [param.lon, param.lat],
        duration: 500,
      });
    },
    locateGlobel() {
      //检查是否位于责任区
      var _this = this;
      if (_this.zrqData.zrqlx && _this.zrqData.objid) {
        actLocate(
          _this.map,
          _this.zrqData.zrqlx,
          _this.zrqData.objid,
          _this.zrqVector
        );
      }
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    userinfo() {
      // this.loadMap();
      this.initData();
    },
    //签到展示
    showQiandaoType(value) {
      let _this = this;
      if (!value) {
        //关闭签到告知app
        if (_this.clientType == "android") {
          window.android.getInfo(118, "0");
        } else {
          window.webkit.messageHandlers.closeQiandaoType.postMessage("0");
        }
      }
    },
  },
};
</script>

<style scoped>
.xunlinBox {
  height: 100%;
  width: 100%;
}
.disabled {
  color: #969799;
}

.zrqPickerPage {
  width: 100%;
  height: 100%;
}
.van-popup--center.zrqPickerPage {
  top: 0;
  left: 0;
  transform: initial;
}
.dhmap-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#protectmap {
  width: 100%;
  height: 100%;
}
.infobox {
  width: 100%;
  height: 30px;
}
.infotip {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 5px;
  color: #fff;
  font-size: 13px;
}
</style>
<style>
.van-goods-action {
  background-color: none;
}
.van-goods-action-icon {
  background: none;
}
.van-goods-action-icon:active {
  background: none;
}
.gistoolbox {
  position: absolute;
  width: 50px;
  left: 10px;
  bottom: 70px;
  /* z-index: 99999999; */
}
.van-button--normal {
  padding: 0;
  margin-bottom: 10px;
  width: 32px;
  height: 32px;
  line-height: 37px;
}
.handleQd .van-goods-action-button--last {
  border-radius: 26.64rem;
}
.currentZrqPosition .van-field__left-icon {
  color: #4bc08a;
}
.currentZrqPosition .van-field__right-icon{
  color: #4bc08a;
}
.currentZrqPosition .van-cell__title span {
    font-size: 15px;
    color: #626064;
  }
.currentZrqPosition .van-cell__value .van-field__control {
  text-align: right;
  font-size: 15px;
  color: #4bc985;
}
.currentZrqPosition .van-field__label{
  flex-shrink: 0;
  width: auto;
}
</style>
<style lang="less">
.dhmap-wrapper.hulinPage {
  .XunlinPicker {
    // position: relative;
    .xunlinMain {
      // padding: 15px 15px 65px 15px;
      position: relative;
      height: 100%;
      .qiandaoMain {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        padding: 15px 15px 65px 15px;
      }
      .btnBox {
        position: absolute !important;
        width: 100%;
        bottom: 0;
        left: 0;
      }
    }
  }
}
</style>